// extracted by mini-css-extract-plugin
export default {"HeaderTitle":"FlowchartHeader_HeaderTitle__ngJql"};